import React from "react";
import "./Loader.scss";

interface LoaderProps {
  size?: "small" | "medium" | "large";
  color?: string;
  message?: string;
  fullScreen?: boolean;
  backdropBlur?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  size = "medium",
  color = "#007bff",
  message,
  fullScreen = false,
  backdropBlur = false,
}) => {
  const getSize = () => {
    switch (size) {
      case "small":
        return "24px";
      case "large":
        return "80px";
      default:
        return "40px";
    }
  };

  const containerClassName = `loader-container ${
    fullScreen ? "fullscreen" : ""
  } ${backdropBlur ? "backdrop-blur" : ""}`;

  return (
    <div className={containerClassName}>
      <div
        className="loader"
        style={{
          width: getSize(),
          height: getSize(),
          color: color,
        }}
      />
      {message && <p className="loader-message">{message}</p>}
    </div>
  );
};

export default Loader;
